

export class PatientStruct {
    public idPatient: number | null = null;
    public idEpisode: number | null = null;
    public idHealthUnitCreator: number | null = null;
    public patientName: string = '';
    public cpf: string = '';
    public birthDate: Date | null = null;
    public datetimeInclusion: Date | null = null;
    public cns: string = '';
    public rg: string = '';
    public expeditionIssuer: string = '';
    public expeditionDate: Date | null = null;
    public socialName: string = '';
    public motherName: string = '';
    public fatherName: string = '';
    public idRace: number | null = null;
    public idEducation: number | null = null;
    public profession: string = '';
    public idMaritalStatus: number | null = null;
    public idGender: number | null = null;
    public zipCode: string = '';
    public street: string = '';
    public neighborhood: string = '';
    public city: string = '';
    public state: string = '';
    public country: string = '';
    public phone1: string = '';
    public phone2: string = '';
    public houseNumber: string = '';
    public apartmentNumber: string = '';
    public healthInsurance: string = '';
    public healthInsuranceRegistration: string = '';
    public healthInsuranceExpirationDate: Date | null = null;
    public healthInsuranceSecurityCode: string = '';
    public healthInsuranceHolderName: string = '';
    public healthInsuranceGracePeriod: Date | null = null;
    public healthInsuranceProcedure: string = '';
    public healthInsuranceAuthorization: string = '';
    public birthCountry: string = '';
    public birthState: string = '';
    public birthCity: string = '';
    public priorities: number[] = [];
    public isUnidentifiedPatient: boolean = false;
    public unidentifiedPatientDescription: string = '';

    public idPatientEmployee: number | null = null;
    public unitBranch: string = '';
    public sectorEmployee: string = '';
    public roleEmployee: string = '';
    public registryEmployee: string = '';
}